import React, { useMemo } from 'react';

import { keyBy } from 'lodash';

import classes from './HeatmapDayRow.module.scss';
import { ScanningPeakHourInfo } from '../../../../interfaces/entity-dashboard/ScanningPeakMatrix';
import { HeatmapCell } from './HeatmapCell/HeatmapCell';
import { Day } from '../../../../../shared/constants/daysOfWeek';
import { formatDayLabel } from '../../../../../shared/utils/dateUtils';
import { HEATMAP_HOUR_TIME_SLOTS } from '../ScanningPeakHoursWidget.settings';

type HeatmapDayRowProps = {
  day: Day;
  hours: ScanningPeakHourInfo[];
  maxCount: number;
};

const HeatmapDayRow = ({ day, hours, maxCount }: HeatmapDayRowProps) => {
  const countByTime = useMemo(() => keyBy(hours, 'time'), [hours]);

  return (
    <>
      <div className={classes.dayLabel}>{formatDayLabel(day, 'short')}</div>
      {HEATMAP_HOUR_TIME_SLOTS.map((time) => {
        const { count } = countByTime[time] ?? { count: 0 };

        return <HeatmapCell key={time} count={count} maxCount={maxCount} />;
      })}
    </>
  );
};

export { HeatmapDayRow };
